import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField, MenuItem, Select, FormControl, InputLabel, Chip, Pagination } from "@mui/material";
import * as RoleActions from "../../redux/actions/roleAction.js";

const ACTION_COLORS = {
    CREATE: '#4caf50',
    UPDATE: '#ff9800',
    DELETE: '#f44336',
    LOGIN: '#2196f3',
    default: '#9e9e9e'
};

const ActivityLogs = () => {
    const dispatch = useDispatch();
    const { activityLogsData, activityLogsPagination } = useSelector(state => state?.roleReducer);
    const [filters, setFilters] = useState({ module: '', action: '', startDate: '', endDate: '', page: 1 });

    useEffect(() => {
        fetchLogs();
    }, [filters.page]);

    const fetchLogs = () => {
        const params = { page: filters.page, limit: 30 };
        if (filters.module) params.module = filters.module;
        if (filters.action) params.action = filters.action;
        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;
        dispatch(RoleActions.getActivityLogs(params));
    };

    const handleFilter = () => {
        setFilters(prev => ({ ...prev, page: 1 }));
        fetchLogs();
    };

    const handleClearFilters = () => {
        setFilters({ module: '', action: '', startDate: '', endDate: '', page: 1 });
        dispatch(RoleActions.getActivityLogs({ page: 1, limit: 30 }));
    };

    return (
        <div style={{ fontFamily: "Philosopher" }}>
            <div style={{ padding: "20px", backgroundColor: "#fff", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px", marginBottom: "20px" }}>
                <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284", marginBottom: "20px" }}>Activity Logs</div>

                <Grid container spacing={2} alignItems="center">
                    <Grid item lg={2} md={3} sm={6} xs={12}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Module</InputLabel>
                            <Select value={filters.module} label="Module" onChange={(e) => setFilters(prev => ({ ...prev, module: e.target.value }))}>
                                <MenuItem value="">All</MenuItem>
                                {['Sub Admin', 'Roles & Logs', 'User', 'Banner', 'Yatra', 'Sanchar', 'Ecommerce'].map(m => (
                                    <MenuItem key={m} value={m}>{m}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item lg={2} md={3} sm={6} xs={12}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Action</InputLabel>
                            <Select value={filters.action} label="Action" onChange={(e) => setFilters(prev => ({ ...prev, action: e.target.value }))}>
                                <MenuItem value="">All</MenuItem>
                                <MenuItem value="CREATE">Create</MenuItem>
                                <MenuItem value="UPDATE">Update</MenuItem>
                                <MenuItem value="DELETE">Delete</MenuItem>
                                <MenuItem value="LOGIN">Login</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item lg={2} md={3} sm={6} xs={12}>
                        <TextField fullWidth size="small" type="date" label="From" InputLabelProps={{ shrink: true }} value={filters.startDate} onChange={(e) => setFilters(prev => ({ ...prev, startDate: e.target.value }))} />
                    </Grid>
                    <Grid item lg={2} md={3} sm={6} xs={12}>
                        <TextField fullWidth size="small" type="date" label="To" InputLabelProps={{ shrink: true }} value={filters.endDate} onChange={(e) => setFilters(prev => ({ ...prev, endDate: e.target.value }))} />
                    </Grid>
                    <Grid item lg={2} md={3} sm={6} xs={6}>
                        <div onClick={handleFilter} style={{ backgroundColor: "#164E62", color: "#fff", padding: "8px 20px", borderRadius: "5px", cursor: "pointer", textAlign: "center", fontSize: "14px", fontWeight: "500" }}>Filter</div>
                    </Grid>
                    <Grid item lg={2} md={3} sm={6} xs={6}>
                        <div onClick={handleClearFilters} style={{ backgroundColor: "#EDF2F5", color: "#333", padding: "8px 20px", borderRadius: "5px", cursor: "pointer", textAlign: "center", fontSize: "14px", fontWeight: "500" }}>Clear</div>
                    </Grid>
                </Grid>
            </div>

            <div style={{ padding: "20px", backgroundColor: "#fff", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                        <thead>
                            <tr style={{ backgroundColor: "#164E62", color: "#fff" }}>
                                <th style={{ padding: "10px", textAlign: "left", width: "50px" }}>#</th>
                                <th style={{ padding: "10px", textAlign: "left" }}>User</th>
                                <th style={{ padding: "10px", textAlign: "left" }}>Type</th>
                                <th style={{ padding: "10px", textAlign: "left" }}>Action</th>
                                <th style={{ padding: "10px", textAlign: "left" }}>Module</th>
                                <th style={{ padding: "10px", textAlign: "left" }}>Description</th>
                                <th style={{ padding: "10px", textAlign: "left" }}>IP Address</th>
                                <th style={{ padding: "10px", textAlign: "left" }}>Date & Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activityLogsData && activityLogsData.length > 0 ? activityLogsData.map((log, idx) => (
                                <tr key={log._id || idx} style={{ borderBottom: "1px solid #eee", backgroundColor: idx % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                                    <td style={{ padding: "8px 10px" }}>{((activityLogsPagination?.page || 1) - 1) * 30 + idx + 1}</td>
                                    <td style={{ padding: "8px 10px", fontWeight: "500" }}>{log.userName}</td>
                                    <td style={{ padding: "8px 10px" }}>
                                        <Chip label={log.userType} size="small" variant="outlined" color={log.userType === 'admin' ? 'primary' : 'secondary'} />
                                    </td>
                                    <td style={{ padding: "8px 10px" }}>
                                        <Chip label={log.action} size="small" sx={{ backgroundColor: ACTION_COLORS[log.action] || ACTION_COLORS.default, color: '#fff', fontWeight: 500 }} />
                                    </td>
                                    <td style={{ padding: "8px 10px" }}>{log.module}</td>
                                    <td style={{ padding: "8px 10px", maxWidth: "250px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{log.description || '-'}</td>
                                    <td style={{ padding: "8px 10px" }}>{log.ipAddress || '-'}</td>
                                    <td style={{ padding: "8px 10px", whiteSpace: "nowrap" }}>{new Date(log.createdAt).toLocaleString('en-IN')}</td>
                                </tr>
                            )) : (
                                <tr><td colSpan={8} style={{ textAlign: "center", padding: "30px", color: "#999" }}>No activity logs found</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {activityLogsPagination?.totalPages > 1 && (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                        <Pagination count={activityLogsPagination.totalPages} page={activityLogsPagination.page || 1} onChange={(e, page) => setFilters(prev => ({ ...prev, page }))} color="primary" />
                    </div>
                )}

                <div style={{ textAlign: "center", color: "#999", fontSize: "12px", marginTop: "10px" }}>
                    Total: {activityLogsPagination?.total || 0} records
                </div>
            </div>
        </div>
    );
};

export default ActivityLogs;
